const styles = () => ({
  dialogContent: {
    overflow: 'hidden',
    flex: '1 1 auto',
  },
});

export default styles;
